export const PoopSpells = [
    ['Poop', '1'],
    ['Corny', '2'],
    ['Burning', '3'],
    ['Stone', '4'],
    ['Stinky', '5'],
    ['Black', '6'],
    ['Holy', '7'],
    ['Liquid', '8'],
    ['Fart', '9'],
    ['Bomb', '10'],
    ['Diarrhea', '11'],
  ];
  